import { useMemo } from "react";

import { firebase } from "astrid-firebase";
import getArtifactsQuery from "astrid-firestore/src/api/artifacts/getArtifactsQuery";
import useCollectionData from "astrid-firestore/src/hooks/useCollectionData";

import sortArtifacts from "../../artifacts/utils/sortArtifacts";

export default function useArtifacts(options) {
	const [artifacts, loading, error] = useCollectionData(getArtifactsQuery(firebase, options));

	const sortedArtifacts = useMemo(() => sortArtifacts(artifacts), [artifacts]);

	return [sortedArtifacts, loading, error];
}
